export const breakpoints = {
  '2xs': '375px',
  xs: '425px',
  sm: '640px',
  md: '768px',
  tablet: '900px',
  lg: '1024px',
  xl: '1280px',
  '2xl': '1536px',
}
